/** @jsxImportSource @emotion/react */
import tw from "twin.macro";
import { css } from "@emotion/css";

import React, { useEffect, useRef, useState } from "react";
import GoogleButton from "react-google-button";
import {
  createEmailAccount,
  loginToEmailAccount,
  loginToGoogle,
} from "./state/state/firebase";
import { Logo } from "./App";
import { Button, TextField } from "@material-ui/core";
import { RiCreativeCommonsNdFill, RiMailFill } from "react-icons/ri";

export const EntryScreen = () => {
  const [loggingWithEmail, setLoggingWithEmail] = useState(false);
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  // useEffect(() => loginToGoogle());
  return (
    <div tw="flex h-full bg-gray-50">
      <div tw="flex flex-col m-auto h-96 w-96 shadow-md bg-white">
        <div tw="flex-grow flex flex-col justify-around relative top--8">
          {loggingWithEmail ? (
            <>
              <div tw="flex-grow flex flex-col justify-evenly relative mx-3">
                <TextField
                  id="email"
                  label="Email"
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                />
                <TextField
                  id="password"
                  label="Password"
                  type="password"
                  onChange={(e) => setPwd(e.target.value)}
                  value={pwd}
                />
                <div tw="ml-auto">
                  <Button
                    variant="outlined"
                    style={{ marginRight: "10px" }}
                    onClick={() => {
                      createEmailAccount(email, pwd);
                    }}
                  >
                    Create account
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={(e) => {
                      loginToEmailAccount(email, pwd, (error) => {
                        setPwd("");
                        alert(error);
                      });
                    }}
                  >
                    Sign in
                  </Button>
                </div>
              </div>
            </>
          ) : (
            <div tw="flex-grow flex flex-col justify-evenly relative mx-3 my-12">
              <div tw="m-auto">
                <Button
                  variant="contained"
                  startIcon={<RiMailFill />}
                  onClick={() => {
                    setLoggingWithEmail(true);
                  }}
                >
                  Sign in with email
                </Button>
              </div>
              <div tw="m-auto">
                <GoogleButton
                  onClick={() => {
                    loginToGoogle();
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
